import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import items from '@/components/services/report-manager/queue/item/errors/items'
import { serviceNameViaPoint } from '@/components/services/report-manager/queue/utils'

function renderBody(h) {
  return h(
    'div',
    {
      class: 'px-2'
    },
    [
      h(
        items,
        {
          props: {
            data: this.data
          }
        }
      )
    ]
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  return h(
    components.dialog,
    {
      props: {
        value: this.showDialog,
        title: this.getTranslate(`${serviceNameViaPoint}.titles.errors`),
        rounded: this.viewport.breakpoint.mdUp,
        maxWidth: 800
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    components['list-item'],
    {
      props: {
        label: this.getTranslate(`${serviceNameViaPoint}.labels.errors`),
        icon: icons.error_outline,
        color: Colors.error,
        disabled: this.data?.debugPayload?.length === 0
      },
      on: {
        click: () => {
          this.showDialog = true
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderDialog.call(this, h)
        }
      }
    }
  )
}
